import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../../actions/log';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default function useLog() {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  const report = (category, action, params = {}, param3) => {
    dispatch(
      logging({
        category,
        action,
        label: '',
        param2: {
          source: 'Game',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          ...params,
        },
        param3,
      }),
    );
  };

  // status 2: 替换上一页，1：移位，0：覆写
  const track = (status = 0, source) => {
    if (status === 2) {
      dispatch(
        logPostInfo({
          source_p: source,
          source_pp: logInfoData.source_p,
        }),
      );
    } else if (status === 1) {
      dispatch(
        logPostInfo({
          source: source || logInfoData.source,
          source_p: logInfoData.source,
          source_pp: logInfoData.source_p,
        }),
      );
    } else {
      dispatch(
        logPostInfo({
          source: source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        }),
      );
    }
  };

  return [report, track];
}
